export default __webpack_public_path__ + "static/media/scene-01-the-connection.78e6a9db.png";